import React from 'react';

// Импортируем модульные стили
import styles from './SocialProofSection.module.css';

// Данные для отзывов. 
// В реальном проекте здесь будут настоящие фотографии и цитаты.
// Мы используем сервис Pexels для реалистичных фото-заглушек.
const testimonialsData = [
  {
    quote: "Мобильный БРУ-20 стал настоящим спасением для наших объектов. Запустили производство бетона на месте всего за две недели. Качество оборудования и сервис на высшем уровне!",
    avatar: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=128",
    name: "Арман Жумабаев",
    company: "Гендиректор, Stroy-Expert.kz",
  },
  {
    quote: "Долго выбирали поставщика для стационарного завода. Остановились на BRU.kz из-за лучшего соотношения цены и качества. БРУ-50 работает без сбоев уже второй год. Рекомендую.",
    avatar: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=128",
    name: "Айгерим Смагулова",
    company: "Начальник отдела снабжения, Beton-Plus",
  },
];

// Данные для логотипов. 
// Используем простые SVG-заглушки или логотипы известных компаний для примера.
// Пути ведут в папку /public/images/logos/
const logosData = [
  { src: '/images/logos/logo-placeholder-1.svg', alt: 'Логотип партнера 1' },
  { src: '/images/logos/logo-placeholder-2.svg', alt: 'Логотип партнера 2' },
  { src: '/images/logos/logo-placeholder-3.svg', alt: 'Логотип партнера 3' },
  { src: '/images/logos/logo-placeholder-4.svg', alt: 'Логотип партнера 4' },
  { src: '/images/logos/logo-placeholder-5.svg', alt: 'Логотип партнера 5' },
];


const SocialProofSection = () => {
  return (
    <section id="social-proof" className={styles.socialProofSection}>
      <div className="container">
        {/* Часть с отзывами */}
        <h2 className={styles.sectionTitle}>Что говорят наши партнеры</h2>
        
        <div className={styles.testimonialsGrid}>
          {testimonialsData.map((testimonial, index) => (
            <div key={index} className={styles.testimonialCard}>
              <p className={styles.quote}>"{testimonial.quote}"</p>
              <div className={styles.author}>
                <img src={testimonial.avatar} alt={testimonial.name} className={styles.avatar} />
                <div className={styles.authorInfo}>
                  <p className={styles.name}>{testimonial.name}</p>
                  <p className={styles.company}>{testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Часть с логотипами */}
        <h3 className={styles.logosTitle}>Нам доверяют ведущие компании отрасли</h3>

        <div className={styles.logosGrid}>
          {logosData.map((logo, index) => (
            <div key={index} className={styles.logoWrapper}>
              <img src={logo.src} alt={logo.alt} className={styles.logoImg} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;